import { Base } from './base';
import { PUBLIC_SERVER_ENDPOINT } from '$env/static/public';
import lz from 'lz-string';

export class TTS extends Base {
	async getTTS(text) {
		let audioCtx = new AudioContext();
		let data = { text: text, token: localStorage.getItem('token') };
		const url = '/v1/tts/get';
		let response = super.postraw(url, data);
		return response
			.then((audioResponse) => {
				return audioResponse.arrayBuffer();
			})
			.then((buffer) => audioCtx.decodeAudioData(buffer))
			.then((decodeData) => {
				const source = audioCtx.createBufferSource();
				source.buffer = decodeData;
				source.connect(audioCtx.destination);
				return source;
			});
	}

	static transmitString(text) {
		return lz.compressToEncodedURIComponent(text);
	}

	getCode(text) {
		let data = {
			text: text,
			token: self.token
		};
		return TTS.transmitString(JSON.stringify(data));
	}

	getAudioURL(encoded) {
		return `${PUBLIC_SERVER_ENDPOINT}/v1/tts/getaudio?code=${encoded}`;
	}
}
